export const ExportStatus = {
  COMPLETED: "completed",
  COMPUTED: "computed",
  ERROR: "error",
  EXTRACTED: "extracted",
  FAILED: "failed",
  IGNORED: "ignored",
  LOADED: "loaded",
  PENDING: "pending",
  PREPROCESSED: "preprocessed",
  PROCESSING: "processing",
  SUCCESS: "success",
  TRANSFORMED: "transformed",
  NONE: "none",
} as const;

export type ExportStatus = (typeof ExportStatus)[keyof typeof ExportStatus];

// Create a mapping of "Valid" flags
export const EXPORT_VALID_STATUSES: Record<ExportStatus, boolean> = {
  [ExportStatus.COMPLETED]: true,
  [ExportStatus.COMPUTED]: true,
  [ExportStatus.ERROR]: false,
  [ExportStatus.EXTRACTED]: false,
  [ExportStatus.FAILED]: false,
  [ExportStatus.IGNORED]: false,
  [ExportStatus.LOADED]: true,
  [ExportStatus.PENDING]: false,
  [ExportStatus.PREPROCESSED]: false,
  [ExportStatus.PROCESSING]: false,
  [ExportStatus.SUCCESS]: true,
  [ExportStatus.TRANSFORMED]: false,
  [ExportStatus.NONE]: true,
};
